<template>
  <div class="modify-appointment-history">
    <div class="page-title">
      修改预约记录
    </div>
    <div class="history-table" v-if="tableData.length !== 0">
      <div class="table-row" v-for="(data,dataIndex) in tableData" :key="dataIndex">
        <div class="table-col">
          {{data.employeeName}}
        </div>
        <div class="table-col">
          请求修改预约至
        </div>
        <div class="table-col table-col-time">
          {{data.toTime}}
        </div>
        <div class="table-col table-action table-col-status" v-if="data.showBtnFlag === 0">
          {{$dict.getDictLabel('modify_appointment_history_status',data.status)}}
        </div>
        <div v-else class="table-col table-action">
          <el-button type="primary" @click="handlePass(data)">同意</el-button>
          <el-button type="primary" @click="handlePropose(data)">建议新时间</el-button>
          <el-button type="danger" plain @click="handleRefuse(data)">拒绝</el-button>
        </div>
      </div>
    </div>
    <div v-else class="no-data">
      暂无数据
    </div>
  </div>
</template>
<script>
import {changeTimeList, changeTimePass, changeTimeRefuse} from '@/api/consultingRoom'

export default {
  props: {
    // 详情数据
    detailData: {
      type: Object,
      default: ()=>{}
    },
    openChangeTimeDialog: {
      type: Function,
      default: ()=>{}
    },
  },
  data() {
    return {
      // 列表数据
      tableData: []
    }
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    // 获取列表数据
    getTableData() {
      changeTimeList(this.detailData.appointmentId).then(res=>{
        if(res.code === 200) {
          this.tableData = res.data
        }
      })
    },
    // 列表-同意
    handlePass(row) {
      this.$confirm('确认同意？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeTimePass({id: row.id}).then(res=>{
          if(res.code === 200) {
            this.$message.success('操作成功')
            this.$emit('callGetDetail')
            this.getTableData()
          }
        })
      })
    },
    // 列表-拒绝
    handleRefuse(row) {
      this.$confirm('确认拒绝？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeTimeRefuse({id: row.id}).then(res=>{
          if(res.code === 200) {
            this.$message.success('操作成功')
            this.$emit('callGetDetail')
            this.getTableData()
          }
        })
      })
    },
    // 列表-建议新时间
    handlePropose(row) {
      this.openChangeTimeDialog('propose',row)
    },
  }
}
</script>
<style lang="scss">
.modify-appointment-history{
  background-color: #FFFFFF;
  border-radius: 8px;
  margin-top: 32px;
  padding: 24px 32px;
  font-family: PingFang HK, PingFang HK;
  .page-title{
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    margin-bottom: 35px;
  }
  .history-table{
    .table-row{
      display: flex;
      gap: 20px;
      margin-bottom: 28px;
      .table-col{
        min-width: 250px;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
      }
      .table-col-time{
        font-weight: 600;
      }
      .table-action{
        flex: 1;
        text-align: right;
        .el-button{
          border-radius: 60px;
        }
      }
      .table-col-status{
        color: #999999;
      }
    }
    .table-row:last-child{
      margin-bottom: 0px;
    }
  }
  .no-data{
    text-align: center;
    color: #999999;
    font-size: 20px;
  }
}
</style>
